// extracted by mini-css-extract-plugin
export var card = "_6r-0";
export var failedIcon = "_6r-4";
export var failedIconBadge = "_6r-3";
export var icon = "_6r-1";
export var successIcon = "_6r-2";